import { render, staticRenderFns } from "./NsTable.vue?vue&type=template&id=457c474d&"
import script from "./NsTable.vue?vue&type=script&lang=js&"
export * from "./NsTable.vue?vue&type=script&lang=js&"
import style0 from "./NsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports